import React from 'react'
import styled from 'styled-components'
import Graph from './StatsGraph'
import { SpinnerRect } from '../shared/elements'

const Container = styled.div``

export default function Overview(props) {
  const {
    currentStats,
    previousStats,
    startDate,
    endDate,
    defaultStartDate,
    defaultEndDate,
  } = props

  const loading = currentStats === null || previousStats === null

  const graphProps = {
    stats: currentStats,
    oldStats: previousStats,
    startDate: startDate || defaultStartDate,
    endDate: endDate || defaultEndDate,
  }

  return (
    <Container>
      {loading ? (
        <div className="text-center">
          <SpinnerRect />
        </div>
      ) : (
        <div className="row">
          <div className="col-lg-4 mb-4">
            <Graph
              title="Total sales"
              type="money"
              field="sale_amount"
              graphField="sale_amount"
              trend={true}
              {...graphProps}
            />
          </div>

          <div className="col-lg-4 mb-4">
            <Graph
              title="Visitors"
              type="count"
              field="gross_clicks"
              graphField="gross_clicks"
              trend={true}
              {...graphProps}
            />
          </div>

          <div className="col-lg-4 mb-4">
            <Graph
              title="Average order value"
              type="money"
              field="sale_amount"
              divType="count"
              divField="conversions"
              graphField="average_value"
              trend={true}
              {...graphProps}
            />
          </div>

          <div className="col-lg-4 mb-4">
            <Graph
              title="Items per order"
              type="float"
              field="items_per_order"
              graphField="items_per_order"
              trend={true}
              {...graphProps}
            />
          </div>

          <div className="col-lg-4 mb-4">
            <Graph
              title="Traffic cost"
              type="money"
              field="payout"
              graphField="payout"
              trend={true}
              {...graphProps}
            />
          </div>

          <div className="col-lg-4 mb-4">
            <Graph
              title="Customer acquisition cost"
              type="money"
              field="revenue"
              divType="money"
              divField="conversions"
              graphField="customer_cost"
              trend={true}
              {...graphProps}
            />
          </div>

          <div className="col-lg-4 mb-4">
            <Graph
              title="New customer rate"
              type="none"
              field="new_customer_rate"
              graphField="new_customer_rate"
              {...graphProps}
            />
          </div>

          <div className="col-lg-4 mb-4">
            <Graph
              title="Conversion rate"
              type="percentage"
              field="conversions"
              divType="count"
              divField="gross_clicks"
              graphField="conversion_rate"
              trend={true}
              {...graphProps}
            />
          </div>

          <div className="col-lg-4 mb-4">
            <Graph
              title="Average touchpoints"
              type="float"
              field="average_touchpoints"
              divField="length"
              graphField="average_touchpoints"
              trend={true}
              {...graphProps}
            />
          </div>
        </div>
      )}
    </Container>
  )
}
